export const rusToLatin = (str) => {
  const ru = {
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ё: 'e',
    ж: 'j',
    з: 'z',
    и: 'i',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'h',
    ц: 'c',
    ч: 'ch',
    ш: 'sh',
    щ: 'shch',
    ы: 'y',
    э: 'e',
    ю: 'u',
    я: 'ya',
  }; const
    numberStr = [];

  const newStr = str.replace(/[ъь]+/g, '').replace(/й/g, 'i');
  /* eslint-disable */
  for (let i = 0; i < newStr.length; i += 1) {
    numberStr.push(
      ru[newStr[i]]
           || ru[newStr[i].toLowerCase()] == undefined && newStr[i]
           || ru[newStr[i].toLowerCase()].replace(/^(.)/, match => match.toUpperCase()),
    );
  }

  return numberStr.join('').replace(/\s/g, '_');
};

export default rusToLatin;
